import React, { useEffect, useState } from "react";
import { LiaLongArrowAltRightSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import apiClient from "../../services/apiClient";
import CatBanner1 from "../../assets/images/banners-6.jpg";
import CatBanner2 from "../../assets/images/banners-7.jpg";
import CatBanner3 from "../../assets/images/banners-8.jpg";
import { IMAGE_PATH } from "../../utils/constants";
import Skeleton from "react-loading-skeleton";

const HomeCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch categories data from API
  const fetchCategoriesData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/website-images");
      if (response.data && response.data.cards) {
        // Map cards to category format (no is_active filter needed as all are active)
        const categoryData = response.data.cards.map(card => ({
          img: card.url,
          title: card.title,
          link: card.link,
        }));
        setCategories(categoryData);
        console.log(categoryData)
      }
    } catch (error) {
      console.error("Failed to fetch categories data:", error);
      
      setCategories([
        {
          img: CatBanner1,
          title: "Premium Collection",
          link: "/collection/premium",
        },
        {
          img: CatBanner2,
          title: "New Arrivals", 
          link: "/collection/new",
        },
        {
          img: CatBanner3,
          title: "Special Offers",
          link: "/collection/offers",
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoriesData();
  }, []);

  // Skeleton Loading Component
  const CategorySkeleton = () => (
    <div id="HomeCategory">
      <div className="container">
        <div className="HomeCategoryMain">
          {[1, 2, 3].map((item) => (
            <div key={item} className="HomeCategoryBox">
              <Skeleton height={200} style={{ marginBottom: '1rem' }} />
              <Skeleton height={24} width="80%" style={{ marginBottom: '0.5rem' }} />
              <Skeleton height={20} width="60%" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  if (loading) {
    return <CategorySkeleton />;
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <div id="HomeCategory">
      <div className="container">
        <div className="HomeCategoryMain">
          {categories.map((cat, index) => (
            <div className="HomeCategoryBox" key={index}>
              <div className="HomeCategoryImg">
                <img 
                  src={IMAGE_PATH + cat.img} 
                  alt={cat.title} 
                  loading="lazy"
                  onError={(e) => {
                    // Fallback to default images
                    const defaultImages = [
                      CatBanner1,
                      CatBanner2,
                      CatBanner3
                    ];
                    e.target.src = defaultImages[index] || defaultImages[0];
                  }}
                />
              </div>
              <div className="HomeCategoryTitle">
                <h3>{cat.title}</h3>
              </div>
              <div className="HomeCategoryBtn">
                <Link to={cat.link || '/products'}>
                  {cat.link?.includes('collection') ? 'Explore' : 'Shop Now'}
                </Link>
                <LiaLongArrowAltRightSolid className="arrowIcon" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeCategory;